import get from 'lodash-es/get';

export const extractDataByPath =
  <T>(stepData: T) =>
  <D extends string | number | null>(path: string, defaultValue: D = null) =>
    (stepData as any)?.[path] === ''
      ? defaultValue
      : get(stepData, path, defaultValue);
